import { useState } from "react";
import Icon from "@mdi/react";
import { mdiCloudUploadOutline } from "@mdi/js";
import BulkStockUploadForm from "./BulkStockUploadForm";
import ScanCodeDevicesFetchForm from "./ScanCodeDevicesFetchForm";
import { BulkUploadType } from "./bulk_stock_upload_repo";

const TABS: {
  key: BulkUploadType;
  label: string;
  desc: string;
  fileLabel: string;
}[] = [
  {
    key: "FG_STOCK_IN",
    label: "FG Stock In",
    desc: "Inward finished goods",
    fileLabel: "Upload FG Stock In File",
  },
  {
    key: "FG_STOCK_OUT",
    label: "FG Stock Out",
    desc: "Outward finished goods",
    fileLabel: "Upload FG Stock Out File",
  },
  {
    key: "RAW_MATERIAL_UPLOAD",
    label: "Raw Material Stock Upload",
    desc: "Upload raw material stock",
    fileLabel: "Upload Raw Material File",
  },
  {
    key: "ITEM_CODE_TRANSFER",
    label: "Item Code Transfer",
    desc: "Transfer by item code",
    fileLabel: "Upload Item Code Transfer File",
  },
  {
    key: "SCAN_CODE_DEVICES_FETCH",
    label: "Scan Code Devices Fetch",
    desc: "Fetch devices by scan code",
    fileLabel: "Upload Scan Codes",
  },
];

export default function BulkStockUploadPage(): JSX.Element {
  const [type, setType] = useState<BulkUploadType>("FG_STOCK_IN");

  const renderForm = () => {
    const active = TABS.find((t) => t.key === type);
    switch (type) {
      case "FG_STOCK_IN":
      case "FG_STOCK_OUT":
      case "RAW_MATERIAL_UPLOAD":
      case "ITEM_CODE_TRANSFER":
        return (
          <BulkStockUploadForm
            key={type}
            type={type}
            fileLabel={active?.fileLabel}
          />
        );
      case "SCAN_CODE_DEVICES_FETCH":
        return <ScanCodeDevicesFetchForm key={type} />;
      default:
        return null;
    }
  };

  return (
    <div id="page_container" className="wh-mobile-shrink min-h-screen bg-gray-50 w-full mx-auto">
      <div className=" bg-white flex flex-col p-2 sm:p-6 lg:p-4">
        {/* HEADER */}
        <div id="top_section" className="border-b px-2 pb-2 flex items-center gap-2">
          <Icon path={mdiCloudUploadOutline} size={1} />
          <h1 className="text-xl font-semibold">Bulk Upload Stock</h1>
        </div>

        {/* TOGGLE */}
        <div className="p-6 space-y-6">
          <div className="space-y-2">
            <label className="text-sm font-medium">Upload Type</label>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
              {TABS.map((tab) => {
                const selected = type === tab.key;

                return (
                  <button
                    key={tab.key}
                    id={`upload_type_${tab.key}`}
                    type="button"
                    onClick={() => setType(tab.key)}
                    className={`p-3 rounded-lg border-2 text-left transition-all
            ${
              selected
                ? "border-blue-600 bg-blue-50"
                : "border-gray-200 hover:border-blue-400 hover:bg-gray-50"
            }`}
                  >
                    <div className="font-medium">{tab.label}</div>
                    <p className="text-xs text-gray-500">{tab.desc}</p>
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {/* BODY */}
        {renderForm()}
      </div>
    </div>
  );
}
